import dynamic from 'next/dynamic'

interface ProductRateProps {
  rate: number
  reviewsCount: number
  className?: string
}

const StarRatings = dynamic(() => import('react-star-ratings'), { ssr: false })

const ProductRate = ({ rate, reviewsCount, className }: ProductRateProps) => {
  return (
    <div className={`${className} flex items-center gap-1`}>
      <span className='text-sm font-semibold text-[#FFCD4B]'>
        {reviewsCount ? rate : 5}
      </span>
      <span className='-mt-1'>
        <StarRatings
          starRatedColor='#FFCD4B'
          numberOfStars={1}
          rating={1}
          starDimension='9px'
          svgIconPath='M20 0L26.1803 13.1672L40 15.2786L30 25.5279L32.3607 40L20 33.1672L7.63932 40L10 25.5279L0 15.2786L13.8197 13.1672L20 0Z'
          svgIconViewBox='0 0 40 40'
        />
      </span>
    </div>
  )
}

export default ProductRate
